import {Injectable} from '@angular/core';
import {ComponentBase} from '../../../component-base';
import {IMouseRelease, IDoubleClick} from '../Interfaces';
import {MatDialog} from '@angular/material';
import {TextEditorComponent, IDialogResult} from '../ng-components/text-editor/text-editor.component';
import {Text} from '../object3D';
import {DrawingsHolderService} from '../drawings-holder.service';
import {PositionCalculatorService} from '../position-calculator.service';
import { SelectComponent } from '.';

@Injectable()
export class DrawTextComponent extends ComponentBase implements IMouseRelease, IDoubleClick {
  dblclick(e: MouseEvent): boolean {
    
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }

  public scaleCor;
  constructor(
    private dialog: MatDialog,
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
    this.scaleCor = 1;
  }

  mouseUp(e: MouseEvent): boolean {
    const dialogRef = this.dialog.open(TextEditorComponent, {
      width: '450px'
    });
    const position = this.positionCalculator.calculate(e);
    dialogRef.afterClosed().subscribe((result: IDialogResult | undefined) => {
      if (result) {
        const object = new Text();
        object.position.copy(position);
        object.config = result.config;
        
        object.update(result.image);
        this.drawings.canvas.add(object);
        object.scaleCor = this.scaleCor;
        object.update(result.image);
      }
    });
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawTextComponent.ts